import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { Dialog } from '@angular/cdk/dialog';
import { TagsService } from '@services/tags.service';
import { LoadingService } from '@services/loading.service';
import { switchMap, takeUntil, tap } from 'rxjs';
import { DestroyService } from '@services/destroy.service';
import { AdminModalContainerComponent } from '@technokratos-admin/components/modals/admin-modal-container/admin-modal-container.component';
import { ConfirmModalComponent } from '@technokratos-admin/components/modals/confirm-modal/confirm-modal.component';
import { DialogService } from '@services/dialog.service';
import { ToastService } from '@services/toast.service';
import { HttpErrorResponse } from '@angular/common/http';
import { Author } from '@models/author';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
	selector: 'tk-tags',
	templateUrl: './tags.page.html',
	styleUrls: ['./tags.page.sass', '/apps/technokratos-admin/src/styles/common.sass'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TagsPage implements OnInit {
	readonly tagsService = inject(TagsService);
	readonly router = inject(Router);
	readonly route = inject(ActivatedRoute);
	readonly toast = inject(ToastService);
	readonly dialog = inject(Dialog);
	readonly dialogService = inject(DialogService);
	readonly loading$ = inject(LoadingService);
	readonly destroy$ = inject(DestroyService);

	tagList$ = this.tagsService.tagList$;
	columns = ['name'];

	ngOnInit() {
		this.refresh();
	}

	refresh() {
		this.tagsService
			.getTags()
			.pipe(tap(() => this.loading$.next(true)))
			.pipe(takeUntil(this.destroy$))
			.subscribe({
				next: res => {
					this.tagList$.next(res);
					this.loading$.next(false);
				},
				error: err => this.toast.error(err),
			});
	}

	deleteAuthor(e: Event, id: number) {
		e.stopPropagation();

		this.dialogService
			.openStandAloneDialog(ConfirmModalComponent, {
				width: '800px',
				container: AdminModalContainerComponent,
				data: {
					title: 'Вы действительно хотите удалить тег?',
					btn: 'Удалить',
				},
			})
			.componentInstance?.onSubmit.pipe(
				takeUntil(this.destroy$),
				switchMap(() => {
					this.loading$.next(true);
					return this.tagsService.deleteTag(id);
				}),
			)
			.subscribe({
				next: () => {
					this.refresh();
					this.toast.success('Тег удален');
					this.dialog.closeAll();
				},
				error: (err: HttpErrorResponse) => this.toast.error(err),
			});
	}

	editTag(row: Author) {
		this.router.navigate(['edit'], {
			queryParams: { id: row.id },
			relativeTo: this.route,
		});
	}
}
